<style lang="scss">

    .utterances {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        max-width: 760px;
        margin-left: auto;
        margin-right: auto;
    }

    .utterances-frame {
        position: absolute;
        left: 0;
        right: 0;
        width: 1px;
        min-width: 100%;
        max-width: 100%;
        height: 100%;
        border: 0;
    }

</style>

<template>
    <div id="comment" class="utterances" :style="{height: height}">
        <iframe class="utterances-frame"
                title="BruceIT评论系统"
                scrolling="no"
                allowtransparency="true"
                :src="page"
        />
    </div>
</template>

<script>
    export default {
        props: [
            "title",
            "description",
            "label",
        ],
        data() {
            return {
                url: window.location.href,
                origin: window.location.origin,
                pathname: window.location.pathname,
                repo: "cnBruceHong/articles-comments",
                issue_term: "title",
                theme: "github-light",
                cross_origin: "anonymous",
                page: "",
                height: 0 + "px"
            }
        },
        created() {
            let api = "https://utteranc.es/utterances.html?src=https://utteranc.es/client.js";
            this.page = api + "&repo=" + this.repo + "&issue-term=" + this.issue_term + "&theme=" + this.theme
                + "&crossorigin=" + this.cross_origin + "&url=" + this.url + "&origin=" + this.origin
                + "&pathname=" + this.pathname + "&title=" + this.title
                + "&description=" + this.description + "&label=" + this.label;
            window.addEventListener('message', (e) => {
                const data = e.data;
                if (data && data.type === 'resize' && data.height) {
                    this.height = data.height + "px";
                }
            });
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/web/components/article/comment.vue